module.exports = __webpack_public_path__ + "assets/img/thumb-Aussie-Broadband-eBook.ddd96f00.webp";